// removed by extract-text-webpack-plugin
module.exports = {"orderBox":"qempo_ResultBox_orderBox-Hs0Dg0T","wrapper":"qempo_ResultBox_wrapper-2KphDe1","imageWrap":"qempo_ResultBox_imageWrap-1EdYBCE","name":"qempo_ResultBox_name-3dtRKGi","price":"qempo_ResultBox_price-86LTjRg"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/new-order/SearchStep/components/ResultBox/ResultBox.scss
// module id = 1596
// module chunks = 0